import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDataAuth } from "../../../hooks/useDataAuth";
import { callApi } from "../../../services/api.service";
import { useNotification } from '../../../hooks/useNotification';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useForm } from '../../../hooks/useForm';
import { useLocation } from 'react-router-dom';
import { INITIAL_INTERFACE_FORM } from '../constants/interface.constants';

export const useManageInterface = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const [isEdit, setisEdit] = useState(false);
    const [workFlowLists, setWorkFlowLists] = useState([]);

    const [errorInputs, , resetErrors, validForm] = useErrorInputs({});
    const [values, handleInputChange, handleDirectInputChange, setAllInfo, , resetExcept] = useForm(INITIAL_INTERFACE_FORM);

    useEffect(() => {
        if (!isEdit) {
            resetExcept(['type_action']);
            resetErrors();
            handleDirectInputChange('configuration', null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.type_action])

    const validateForm = () => {
        const requiredFields = ["type_action", "name", 'icon', 'work_flow'];
        if (['MENU', 'SUBMENU'].includes(values.type_action))
            requiredFields.push('process_action', 'name_action', 'path', 'menu', 'order_menu');
        else if (values.type_action === 'CHART_REPORT')
            requiredFields.push('path', 'menu', 'order_menu');
        else
            requiredFields.push('work_flow_related');
        return validForm(requiredFields, values);
    };

    const getActions = () => {
        callApi('user_action_select', 'SELECT_WORK_FLOWS', {}, userSession.token)
            .then(({ data }) => {
                setWorkFlowLists(data);
            }).catch((e) => {
                console.error("ERROR_getActions", e);
            })
    }

    const getInterfaceById = () => {
        if (location.state && location.state.config) {
            const { config } = location.state;
            if (config.data?.id) {
                setisEdit(true);
                const id = config.data.id;
                callApi('user_action_select', 'SELECT_BY_ID', { id_user_action: id }, userSession.token, { findOne: "true" })
                    .then(({ data }) => {
                        if (data.configuration.includes('charts'))
                            data.type_action = 'CHART_REPORT';
                        setAllInfo(data);
                    }).catch((e) => {
                        console.error("ERROR_getGroupById", e);
                    })
            }
        }
    };

    useEffect(() => {
        const init = async () => {
            await Promise.all([
                getInterfaceById(),
                getActions(),
            ]);
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const save = (data) => {
        callApi('user_action_alter', isEdit ? 'UPDATE' : 'INSERT', data, userSession.token)
            .then(() => {
                sendNotification({ variant: 'success', msg: t("messages.saveSuccess") });
            }).catch((e) => {
                sendNotification({ variant: 'error', msg: t("messages.saveError") });
            })
    };

    return {
        values,
        errorInputs,
        workFlowLists,
        isEdit,
        handleInputChange,
        handleDirectInputChange,
        validateForm,
        save,
        t
    };
}
